import { HeaderModule, HeaderShopRC, IHeaderCommon } from '@carnica/smart-kit';
// @ts-expect-error FIXME need @beef/elk-shared .d.ts
import { SideMenu } from '@beef/elk-shared';
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';

import { useLegacyHeaderActions } from 'hooks/useLegacyHeaderActions';
import { selectIsMainPage } from 'store/common/mobileView/selectors';
import {
  selectHeaderCommon,
  selectHeaderData,
  selectHeaderUser,
  selectIsHeaderModelLoaded,
} from 'store/common/specialProjectHeader/selectors';

import BackButton from './BackButton';

const Header2024: React.FC<{
  isMainPage: boolean;
  user?: IHeaderCommon['auth']['user'];
  commonData: IHeaderCommon;
  key: string;
}> = ({ isMainPage, user, commonData, key }) => {
  useLegacyHeaderActions(commonData);
  const [isOpenSideMenu, setIsOpenSideMenu] = useState(false);

  const handleLoginClick = useCallback(() => setIsOpenSideMenu((prev: boolean) => !prev), []);

  return (
    <HeaderModule onLoginClick={handleLoginClick} selectData={selectHeaderData} className="header">
      <HeaderShopRC key={key} leftSideNode={!isMainPage ? <BackButton /> : null} />
      <SideMenu isOpen={isOpenSideMenu} onClose={handleLoginClick} user={user} />
    </HeaderModule>
  );
};

export default connect((state) => ({
  isMainPage: selectIsMainPage(state),
  user: selectHeaderUser(state),
  commonData: selectHeaderCommon(state),
  key: String(selectIsHeaderModelLoaded(state)),
}))(Header2024);
